/**
 * Created by JIA on 2022/1/19.
 */
import _ from "lodash";
import * as MarkTextHelper from "../../../../utils/MarkTextHelper";
import { pinyin } from "pinyin-pro";
import pinyinUtil from "../../../../../utils/PinYinHelper/pinyinUtil";
import LBox from "../../../../utils/levenshtein-toolbox";
import { t } from "../../../../i18n";
import { AzureEnums, i18nKey, IsTheERCase } from "../SpeechCommonHelper";
import Constants from "../../../../config/Constants";
import { hasChineseChars, IsNoNeedCompareChar, convertToPinyin } from "../../../../utils/Helper";
import EnglishTokenCodec from "../../../../../utils/EnglishTokenCodec";
import { EnumHasFlag } from "../../../../utils/MarkTextHelper";

//region [XunFei ASR Result Process]
const convertNumToHanZi = (num) => {
    //const regex = /^[0-9]$/;
    const mapDic = {
        "0": "零",
        "1": "一",
        "2": "二",
        "3": "三",
        "4": "四",
        "5": "五",
        "6": "六",
        "7": "七",
        "8": "八",
        "9": "九",
    };
    if (mapDic.hasOwnProperty(_.toString(num))) {
        return mapDic[_.toString(num)];
    }

    return num;
};

const comparePinyinArraysHasSamePinyin = (pinyin1, pinyin2) => {
    let pinyin1Array = null;
    if (_.isString(pinyin1)) {
        pinyin1Array = [pinyin1];
    } else if (_.isArray(pinyin1)) {
        pinyin1Array = pinyin1;
    }

    let pinyin2Array = null;
    if (_.isString(pinyin2)) {
        pinyin2Array = [pinyin2];
    } else if (_.isArray(pinyin2)) {
        pinyin2Array = pinyin2;
    }

    if (pinyin1Array && pinyin2Array) {
        let samePinyinFound = 0;
        _.each(pinyin1Array, (item, index) => {
            //use same method to handle pinyin convert
            let p1 = convertToPinyin(item);
            _.each(pinyin2Array, (item2, index2) => {
                let p2 = convertToPinyin(item2);

                if (p1 === p2) {
                    samePinyinFound += 1;
                }
            });
        });
        return samePinyinFound > 0;
    }

    return false;
};

/**
 * 当传入非中文时候,获取拼音会有exception. 有exception的时候返回原值
 * @param char
 * @returns {*|string|string[]}
 */
const getPinyinArrays = char => {
    try {
        return pinyin(char, { multiple: true, type: "array" });
    } catch (e) {
        //DebugLogger.log(e);
        // use the old library as backup
        try {
            return pinyinUtil.getPinyin(char, "", true, true);
        } catch (e2) {
            return char;
        }
    }
};

// the `matchCost` function dictates the cost when both
// letters in both strings match, and if they don't match,
// the cost of doing a substitution from the first to the second.
// you can even vary the cost depending on the letters being compared.
const matchCost = (c1, c2, i, j, refArray, enCase = false) => {
    const convertC1 = convertNumToHanZi(c1);
    const convertC2 = convertNumToHanZi(c2);
    if (convertC1 === convertC2) {
        return 0;
    } else if (!enCase) {
        //对于0-9,先替换成汉字再来进行比较

        let c1Pinyin;
        //文字不同,拼音相同,也认为是同一字
        //对于正确答案,提供了拼音的话,使用提供的拼音
        if (refArray && _.isArray(refArray) && refArray.length > i - 1) {
            c1Pinyin = refArray[i - 1];
            //有时候会有阿拉伯数字作为拼音,转换为其真实拼音
            if (c1Pinyin.length === 1) {
                let c1PinyinNum = convertNumToHanZi(c1Pinyin);
                if (c1Pinyin !== c1PinyinNum) {
                    c1Pinyin = getPinyinArrays(c1PinyinNum);
                }
                //DebugLogger.log(`c1: ${c1} c1: ${refArray[i - 1]} c1: ${c1Pinyin}, c2: ${c1PinyinNum}`);
            }
        } else {
            c1Pinyin = getPinyinArrays(convertC1);
        }
        const c2Pinyin = getPinyinArrays(convertC2);
        //DebugLogger.log(`c1: ${c1}, c2: ${c2} \n c1: ${c1Pinyin}, c2: ${c2Pinyin}`);

        if (comparePinyinArraysHasSamePinyin(c1Pinyin, c2Pinyin)) {
            return 0;
        }
    }

    return 1;
};

const matchType = (c1, c2, i, j, refArray, enCase = false) => {
    if (matchCost(c1, c2, i, j, refArray, enCase) === 0) {
        return "M";
    } else {
        return "S";
    }
};

/**
 * XunFei ASR only return the recognized text back, we need compare and return the result
 * @param result
 * @param referenceText
 * @param referenceSyllableArray
 * @param markText
 */
const handleCommonRecognitionResult = (result, referenceText, referenceSyllableArray, markText) => {
    try {
        //1. 文本比对前，去掉原文和评测文本里的所有标点和空格，再进行比对
        // 2. 比对后，评测文本已经被转成比对结果了，在比对结果里(按照原文位置)加上原文的标点和空格

        //AIC-3-239 对于替换相等数目的字符情况，我们可以参考一一对应来显示错误情况。
        // 如果替换字符数目不等的情况，我们就把这个替换部分作为一个整体来显示错误情况：这个需要特殊处理一下。
        let referenceSyllableArrayValid = referenceSyllableArray && referenceText && _.isArray(referenceSyllableArray) && referenceSyllableArray.length === referenceText.length;
        let punctuationArr = [];
        let parseMarkArr = markText && _.isString(markText) && markText.length > 0 ? MarkTextHelper.ParseMarkText(markText) : [];
        let markIndexMap = {};
        //获取参考答案的拼音
        let newReferenceSyllableArray = [];
        let ERIndexArray = []; //保存 儿化音case 儿的index
        let markIndex = 0;
        let skipMarkIndexLength = 0;
        let needSkip = false;
        let hasNumberMarkType = false;
        let hasNumberMarkTypeWithNonMatchNum = false;
        const zReferenceText = _.map(referenceText, (s, index) => {
            if (parseMarkArr.length > 0 && markIndex < parseMarkArr.length) {
                if (skipMarkIndexLength !== 0) {
                    skipMarkIndexLength -= 1;
                    markIndexMap[_.toString(index)] = { isInSkip: needSkip };
                    if (skipMarkIndexLength === 0) {
                        markIndex += 1;
                    }
                } else {
                    //for now, we should only have plain word and the number(change text to another text in background, \n ) case
                    if (MarkTextHelper.EnumHasFlag(parseMarkArr[markIndex].type, Constants.TEXT_MARK_TYPE.NUMBER)) {
                        hasNumberMarkType = true;
                        markIndexMap[_.toString(index)] = { text: parseMarkArr[markIndex].text, markParseObj: parseMarkArr[markIndex] }; //存最后用于显示的字符
                        //替换字符数目不等的情况
                        if (parseMarkArr[markIndex].setting.chnText.length !== parseMarkArr[markIndex].text.length) {
                            skipMarkIndexLength = parseMarkArr[markIndex].setting.chnText.length - 1;
                            hasNumberMarkTypeWithNonMatchNum = true;
                            if (skipMarkIndexLength > 0) {
                                needSkip = true;
                            } else {
                                needSkip = false;
                                skipMarkIndexLength = 0;
                                markIndex += 1;
                            }
                        } else {
                            skipMarkIndexLength = parseMarkArr[markIndex].setting.chnText.length - 1;
                            if (skipMarkIndexLength > 0) {
                                needSkip = true;
                            } else {
                                needSkip = false;
                                skipMarkIndexLength = 0;
                                markIndex += 1;
                            }
                        }
                    } else {
                        if (parseMarkArr[markIndex].text.length > 1) {
                            skipMarkIndexLength = parseMarkArr[markIndex].text.length - 1;
                            needSkip = false;
                        } else {
                            needSkip = false;
                            skipMarkIndexLength = 0;
                            markIndex += 1;
                        }
                    }
                }
            }
            if (IsNoNeedCompareChar(s)) {
                punctuationArr.push({
                    letter: s,
                    index: index,
                });
                return "";
            }
            //如果替换了字符而且有字符替换数目变多/少的情况,不使用传过来的拼音
            if (referenceSyllableArrayValid && !hasNumberMarkTypeWithNonMatchNum) {
                newReferenceSyllableArray.push(referenceSyllableArray[index]);

                if (index > 0) {
                    const lastChar = referenceText[index - 1];
                    if (!IsNoNeedCompareChar(lastChar)) {
                        const nowSyllableArrLength = newReferenceSyllableArray.length;
                        const isTheERCase = IsTheERCase(referenceText[index - 1], s, newReferenceSyllableArray[nowSyllableArrLength - 2], newReferenceSyllableArray[nowSyllableArrLength - 1]);
                        if (isTheERCase) {
                            //儿化音case, 回退本字和上一个字
                            newReferenceSyllableArray[nowSyllableArrLength - 2] = newReferenceSyllableArray[nowSyllableArrLength - 2].slice(0, -1);
                            newReferenceSyllableArray[nowSyllableArrLength - 1] = "er";
                            ERIndexArray.push(nowSyllableArrLength - 1);
                        }
                    }
                }
            }
            return s;
        }).join("");
        const zResult = _.map(result, (s) => (IsNoNeedCompareChar(s) ? "" : s)).join("");
        //DebugLogger.log(referenceSyllableArray);
        //DebugLogger.log(newReferenceSyllableArray);
        //DebugLogger.log(zReferenceText);
        const l = new LBox({ caseSensitive: false }); //不考虑英文大小写
        //文字不同,拼音相同,也认为是同一字
        l.set("matchCost", (c1, c2, i, j) => matchCost(c1, c2, i, j, newReferenceSyllableArray));
        l.set("_matchType", (c1, c2, i, j) => matchType(c1, c2, i, j, newReferenceSyllableArray));

        // perform the Levenshtein distance algorithm,
        // converting `patternString` to `text`.
        l.process(zReferenceText, zResult);

        // view each step in the path of converting `patternString` to `text`

        let newReturnObj = {
            passed: false,
            resultWordArray: [],
            referenceTextWordArray: [],
            pronScore: 0,
            accuracyScore: 0,
            fluencyScore: 0,
            completionScore: 0,
            wordResultArray: [],
            notPassedWordIndexDic: {}, // the key is index, the value is word item, no need for this case
            rawResult: result,
            referenceText: referenceText,
            nodeArray: [],
            matches: 0,
            substitutions: 0,
            inserts: 0,
            deletes: 0,
        };

        let tmpPreviousWord = "";
        let refWordCount = 0; //原文字数
        let wholeWordCount = 0; //结果字数

        // view each step in the path of converting `patternString` to `text`
        l.recursePath((node) => {
            let needPush = true;
            let wordResultItem = {
                word: "",
                pronScore: 0,
                accuracyScore: 0,
                errorType: AzureEnums.WordErrorType.None,
                phonemes: "", //just copy here
                previousInsertedWord: "",
                nextInsertedWord: "",
            };
            switch (node.op) {
                // match operation was done
                case "M":
                    if (!IsNoNeedCompareChar(node.letter)) {
                        //排斥标点
                        newReturnObj.matches += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.None;
                        wordResultItem.word = node.from; //如果拼音相同，汉字不同，将语音评测结果校正为原文汉字
                        wordResultItem.accuracyScore = 100;
                        wordResultItem.pronScore = 100;

                        refWordCount++;
                        wholeWordCount++;
                    }
                    break;
                // subtitution operation was done
                case "S":
                    let fIsPunc = IsNoNeedCompareChar(node.from);
                    let tIsPunc = IsNoNeedCompareChar(node.to);
                    if (!fIsPunc || !tIsPunc) {
                        //排斥标点
                        newReturnObj.substitutions += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.Mispronunciation;
                        wordResultItem.word = node.from;

                        if (!fIsPunc) {
                            refWordCount++;
                        }
                        if (!tIsPunc) {
                            wholeWordCount++;
                        }
                    }
                    break;
                // insert operation was done
                case "I":
                    if (!IsNoNeedCompareChar(node.letter)) {
                        //排斥标点
                        newReturnObj.inserts += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.Insertion;
                        wordResultItem.word = node.letter;
                        //add to the previous item
                        if (newReturnObj.wordResultArray.length > 0) {
                            newReturnObj.wordResultArray[newReturnObj.wordResultArray.length - 1].nextInsertedWord += node.letter;
                        } else {
                            tmpPreviousWord += node.letter;
                        }
                        needPush = false;

                        wholeWordCount++;
                    }
                    //对于插入的node要记录下来,为后面的标点插入进行参考
                    _.each(punctuationArr, (item, subIndex) => {
                        if (item.index > node.j) {
                            item.index = item.index + 1;
                        }
                    });

                    break;
                // delete operation was done
                case "D":
                    if (!IsNoNeedCompareChar(node.letter)) {
                        //处理识别结果少了儿字的case
                        const prevNode = _.cloneDeep(node);
                        const deleteIndex = prevNode.i;
                        let isERCase = false;
                        if (deleteIndex > 0) {
                            const lastNode = newReturnObj.nodeArray[newReturnObj.nodeArray.length - 1];
                            //当前节点符合儿化音的缺儿字case
                            //此时做一个额外判断,当儿化音的儿前面一个字错了的时候,我们不把缺了儿字作为正确
                            isERCase = _.findIndex(ERIndexArray, (s) => s === deleteIndex) > -1 && node.letter === "儿" && lastNode.op === "M";
                        }

                        //当前节点符合儿化音的缺儿字case
                        //此时做一个额外判断,当儿化音的儿前面一个字错了的时候,我们不把缺了儿字作为正确
                        if (isERCase) {
                            newReturnObj.matches += 1;
                            wordResultItem.errorType = AzureEnums.WordErrorType.None;
                            wordResultItem.word = node.letter; //如果拼音相同，汉字不同，将语音评测结果校正为原文汉字
                            wordResultItem.accuracyScore = 100;
                            wordResultItem.pronScore = 100;
                            node = {
                                i: prevNode.i,
                                j: prevNode.i,
                                op: "M",
                                letter: prevNode.letter,
                                from: prevNode.letter,
                                to: prevNode.letter,
                            };
                            refWordCount++;
                            wholeWordCount++;
                        } else {
                            //排斥标点
                            newReturnObj.deletes += 1;
                            wordResultItem.errorType = AzureEnums.WordErrorType.Omission;
                            wordResultItem.word = node.letter;

                            refWordCount++;
                        }
                    }
                    break;
                default:
                    break;
            }
            if (needPush) {
                if (tmpPreviousWord.length > 0) {
                    wordResultItem.previousInsertedWord = tmpPreviousWord;
                    tmpPreviousWord = "";
                }
                newReturnObj.wordResultArray.push(wordResultItem);
            }
            newReturnObj.nodeArray.push(node);
        });

        // 2. 比对后，评测文本已经被转成比对结果了，在比对结果里(按照原文位置)加上原文的标点和空格
        _.each(punctuationArr, (item, subIndex) => {
            newReturnObj.nodeArray.splice(item.index, 0, { i: item.index, op: "M", letter: item.letter, from: item.letter, to: item.letter });
        });

        if (parseMarkArr.length > 0 && hasNumberMarkType) {
            const orgNodeArray = _.cloneDeep(newReturnObj.nodeArray);
            newReturnObj.nodeArray = [];
            //3. 处理Mark Text 替换的文字,替换成界面上面显示的文字.重新组装一下
            _.each(orgNodeArray, (item, pIndex) => {
                if (_.has(markIndexMap, _.toString(pIndex))) {
                    let index = pIndex;
                    let markItem = markIndexMap[_.toString(pIndex)];
                    if (_.has(markItem, "isInSkip")) {
                        if (markItem.isInSkip) {
                            //do nothing
                        } else {
                            //plain text skip case
                            newReturnObj.nodeArray.push(_.cloneDeep(item));
                        }
                    } else {
                        let markParseObj = markItem.markParseObj;
                        if (markParseObj.setting.chnText.length !== markParseObj.text.length) {
                            //替换部分作为一个整体来显示错误情况, 暂定 如果发音的这几个字里,有一个字不是match的情况下,都作为Delete处理
                            let finalFlag = "M";
                            //首先确定flag
                            _.each(markParseObj.setting.chnText, (innerItem, innerIndex) => {
                                if (index + innerIndex < orgNodeArray.length && orgNodeArray[index + innerIndex].op !== "M") {
                                    finalFlag = "D";
                                }
                            });

                            //只需要按最终结果往里面装node
                            _.each(markParseObj.text, (innerItem, innerIndex) => {
                                //newReturnObj.nodeArray[index + innerIndex] = _.cloneDeep(orgNodeArray[index + innerIndex]);
                                // 先插入已有node. 不够再插入空白
                                if (innerIndex < markParseObj.setting.chnText.length) {
                                    let currentItem = _.cloneDeep(orgNodeArray[index + innerIndex]);
                                    currentItem.from = innerItem;
                                    currentItem.op = finalFlag;
                                    newReturnObj.nodeArray.push(currentItem);
                                } else {
                                    newReturnObj.nodeArray.push({
                                        i: index + innerIndex,
                                        j: index + innerIndex,
                                        op: finalFlag,
                                        letter: innerItem,
                                        from: innerItem,
                                        to: finalFlag === "M" ? innerItem : "",
                                    });
                                }
                            });
                        } else {
                            //个数一样的直接替换,不必考虑flag
                            _.each(markParseObj.text, (innerItem, innerIndex) => {
                                //newReturnObj.nodeArray[index + innerIndex] = _.cloneDeep(orgNodeArray[index + innerIndex]);
                                let currentItem = _.cloneDeep(orgNodeArray[index + innerIndex]);
                                currentItem.from = innerItem;
                                newReturnObj.nodeArray.push(currentItem);
                            });
                        }
                    }
                } else {
                    newReturnObj.nodeArray.push(_.cloneDeep(item));
                }
            });
        }
        //how can we say passed. for now we say if you are no word wrong as passed
        newReturnObj.passed = newReturnObj.matches === refWordCount && refWordCount === wholeWordCount;
        newReturnObj.accuracyScore = refWordCount !== 0 ? (newReturnObj.matches / refWordCount) * 100 : 0; //calc match %
        //we need combine the insert part into the previous or backend word to make the Word/Letter Component can show it
        newReturnObj.passedWordCount = newReturnObj.matches;
        newReturnObj.wholeWordCount = wholeWordCount;

        return {
            shouldResolve: true,
            rejectMessage: "",
            result: newReturnObj,
        };
    } catch (e) {
        return { shouldResolve: false, rejectMessage: t(`${i18nKey}:ServerError`), result: {} };
    }
};

const findNextNonInsertNode = (nodeArr, index, targetChar, insertNodesIndexArr) => {
    let startIndex = index;
    if (startIndex < nodeArr.length) {
        const currentItem = nodeArr[startIndex];
        //ignore the insert punc items
        if (currentItem.op !== "I" && (currentItem.from === targetChar || (currentItem.op === "D" && currentItem.letter === targetChar))) {
            return startIndex;
        } else {
            if (currentItem.op === "I") {
                insertNodesIndexArr.push(startIndex);
            }
            return findNextNonInsertNode(nodeArr, startIndex + 1, targetChar, insertNodesIndexArr);
        }
    }

    return null;
};

const findNextNonInsertNodes = (nodeArr, index, chnText) => {
    let sindex = index;
    let arr = [];
    let insertNodesIndexArr = [];
    const count = chnText.length;
    for (let i = 0; i < count; i++) {
        const targetChar = chnText.charAt(i);
        sindex = findNextNonInsertNode(nodeArr, sindex, targetChar, insertNodesIndexArr);
        if (sindex != null) {
            arr.push(_.cloneDeep(nodeArr[sindex]));
            if (i < count - 1) {
                sindex += 1;
            }
        }
    }

    return {
        nodes: arr,
        currentIndex: sindex,
        insertNodesIndexArr: insertNodesIndexArr,
    };
};
/**
 * we use different logic in english case
 * @param result
 * @param referenceText
 * @param referenceSyllableArray
 * @param markText
 * @param makeLowerCase
 */
const handleCommonRecognitionResultForEnglish = (result, referenceText, referenceSyllableArray, markText) => {
    try {
        //对英文,将Mark Text也进行相应的转换
        let parseMarkArrOrg = markText && _.isString(markText) && markText.length > 0 ? MarkTextHelper.ParseMarkText(markText) : [];

        // 英文按单词比较对错, 先将每个单词转换成一个中文字符, 处理结果再转换回来
        let codec = new EnglishTokenCodec();
        let makeLowerCase = (s) => {
            let resultTR = "";
            let ss = codec.decodeToArray(s);
            for (let i = 0; i < ss.length; ++i) {
                if (ss[i].from !== ss[i].to) {
                    resultTR += codec.tokenToChar(ss[i].to.toLowerCase());
                } else {
                    resultTR += ss[i].to.toLowerCase();
                }
            }
            return resultTR;
        };

        //handle am pm case, convert "a m" "p m" to "am" "pm"
        let filteredResult = result.replace(/ [aA]\s+[mM]/g, " am").replace(/ [pP]\s+[mM]/g, " pm");

        let resultChars = codec.encode(filteredResult);

        let engMarkText = "";
        const spaces = [" ", "\n", "\t", String.fromCodePoint(160)];
        let newReferenceText = "";
        //替换中文字符生成相应的MarkText, 剔除Mark Text中的空格
        _.each(parseMarkArrOrg, (item, innerIndex) => {
            if (EnumHasFlag(item.type, Constants.TEXT_MARK_TYPE.NUMBER)) {
                const encodeChnText = makeLowerCase(codec.encode(item.setting.chnText));
                const deletedWhiteSpace = _.join(
                    _.map(encodeChnText, (s) => (spaces.indexOf(s) > -1 ? "" : s)),
                    ""
                );
                engMarkText += `\\n{${item.text}|${deletedWhiteSpace}}`;
                newReferenceText += deletedWhiteSpace;
            } else {
                let tmpCodec = makeLowerCase(codec.encode(item.text));
                if (spaces.indexOf(item.text.slice(-1)) > -1 && spaces.indexOf(tmpCodec.slice(-1)) < 0) {
                    tmpCodec += " ";
                }
                engMarkText += tmpCodec;
                newReferenceText += tmpCodec;
            }
        });

        let referenceChars = codec.encode(newReferenceText);

        //1. 文本比对前，去掉原文和评测文本里的所有标点和空格，再进行比对
        // 2. 比对后，评测文本已经被转成比对结果了，在比对结果里(按照原文位置)加上原文的标点和空格

        //AIC-3-239 对于替换相等数目的字符情况，我们可以参考一一对应来显示错误情况。
        // 如果替换字符数目不等的情况，我们就把这个替换部分作为一个整体来显示错误情况：这个需要特殊处理一下。
        let punctuationArr = [];
        let parseMarkArr = engMarkText && _.isString(engMarkText) && engMarkText.length > 0 ? MarkTextHelper.ParseMarkText(engMarkText) : [];
        let markIndexMap = {};
        //获取参考答案的拼音
        let newReferenceSyllableArray = [];
        let markIndex = 0;
        let skipMarkIndexLength = 0;
        let needSkip = false;
        let hasNumberMarkType = false;
        let hasNumberMarkTypeWithNonMatchNum = false;
        let puncCount = 0;
        const zReferenceText = _.map(referenceChars, (s, index) => {
            if (parseMarkArr.length > 0 && markIndex < parseMarkArr.length) {
                if (skipMarkIndexLength !== 0) {
                    skipMarkIndexLength -= 1;
                    //markIndexMap[_.toString(index)] = { isInSkip: needSkip, puncCount: puncCount, orgIndex: index };
                    if (skipMarkIndexLength === 0) {
                        markIndex += 1;
                    }
                } else {
                    //for now, we should only have plain word and the number(change text to another text in background, \n ) case
                    if (MarkTextHelper.EnumHasFlag(parseMarkArr[markIndex].type, Constants.TEXT_MARK_TYPE.NUMBER)) {
                        hasNumberMarkType = true;
                        //存最后用于显示的字符
                        markIndexMap[_.toString(index)] = {
                            text: parseMarkArr[markIndex].text,
                            markParseObj: parseMarkArr[markIndex],
                            puncCount: puncCount,
                            orgIndex: index,
                        };
                        //替换字符数目不等的情况
                        if (parseMarkArr[markIndex].setting.chnText.length !== parseMarkArr[markIndex].text.length) {
                            skipMarkIndexLength = parseMarkArr[markIndex].setting.chnText.length - 1;
                            hasNumberMarkTypeWithNonMatchNum = true;
                            if (skipMarkIndexLength > 0) {
                                needSkip = true;
                            } else {
                                needSkip = false;
                                skipMarkIndexLength = 0;
                                markIndex += 1;
                            }
                        } else {
                            skipMarkIndexLength = parseMarkArr[markIndex].setting.chnText.length - 1;
                            if (skipMarkIndexLength > 0) {
                                needSkip = true;
                            } else {
                                needSkip = false;
                                skipMarkIndexLength = 0;
                                markIndex += 1;
                            }
                        }
                    } else {
                        if (parseMarkArr[markIndex].text.length > 1) {
                            skipMarkIndexLength = parseMarkArr[markIndex].text.length - 1;
                            needSkip = false;
                        } else {
                            needSkip = false;
                            skipMarkIndexLength = 0;
                            markIndex += 1;
                        }
                    }
                }
            }
            if (IsNoNeedCompareChar(s)) {
                punctuationArr.push({
                    letter: s,
                    index: index,
                });
                puncCount += 1;
                return "";
            }
            return s;
        }).join("");
        const zResult = _.map(resultChars, (s) => (IsNoNeedCompareChar(s) ? "" : s)).join("");
        //DebugLogger.log(referenceSyllableArray);
        //DebugLogger.log(newReferenceSyllableArray);
        //DebugLogger.log(zReferenceText);
        const l = new LBox({ caseSensitive: false, makeLowerCase }); //不考虑英文大小写
        //文字不同,拼音相同,也认为是同一字
        l.set("matchCost", (c1, c2, i, j) => matchCost(c1, c2, i, j, newReferenceSyllableArray, true));
        l.set("_matchType", (c1, c2, i, j) => matchType(c1, c2, i, j, newReferenceSyllableArray, true));

        // perform the Levenshtein distance algorithm,
        // converting `patternString` to `text`.
        l.process(zReferenceText, zResult);

        // view each step in the path of converting `patternString` to `text`

        let newReturnObj = {
            passed: false,
            resultWordArray: [],
            referenceTextWordArray: [],
            pronScore: 0,
            accuracyScore: 0,
            fluencyScore: 0,
            completionScore: 0,
            wordResultArray: [],
            notPassedWordIndexDic: {}, // the key is index, the value is word item, no need for this case
            rawResult: result,
            referenceText: referenceText,
            nodeArray: [],
            matches: 0,
            substitutions: 0,
            inserts: 0,
            deletes: 0,
        };

        let tmpPreviousWord = "";
        let refWordCount = 0; //原文字数
        let wholeWordCount = 0; //结果字数

        // view each step in the path of converting `patternString` to `text`
        l.recursePath((node) => {
            let needPush = true;
            let wordResultItem = {
                word: "",
                pronScore: 0,
                accuracyScore: 0,
                errorType: AzureEnums.WordErrorType.None,
                phonemes: "", //just copy here
                previousInsertedWord: "",
                nextInsertedWord: "",
            };
            switch (node.op) {
                // match operation was done
                case "M":
                    if (!IsNoNeedCompareChar(node.letter)) {
                        //排斥标点
                        if (makeLowerCase) {
                            // node.from和to为小写的字符, 此处根据索引转换回原来的字符
                            node.from = zReferenceText[node.i];
                            node.to = zResult[node.j];
                        }
                        newReturnObj.matches += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.None;
                        wordResultItem.word = node.from; //如果拼音相同，汉字不同，将语音评测结果校正为原文汉字
                        wordResultItem.accuracyScore = 100;
                        wordResultItem.pronScore = 100;

                        refWordCount++;
                        wholeWordCount++;
                    }
                    break;
                // subtitution operation was done
                case "S":
                    let fIsPunc = IsNoNeedCompareChar(node.from);
                    let tIsPunc = IsNoNeedCompareChar(node.to);
                    if (!fIsPunc || !tIsPunc) {
                        //排斥标点
                        newReturnObj.substitutions += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.Mispronunciation;
                        wordResultItem.word = node.from;

                        if (!fIsPunc) {
                            refWordCount++;
                        }
                        if (!tIsPunc) {
                            wholeWordCount++;
                        }
                    }
                    break;
                // insert operation was done
                case "I":
                    if (!IsNoNeedCompareChar(node.letter)) {
                        //排斥标点
                        newReturnObj.inserts += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.Insertion;
                        wordResultItem.word = node.letter;
                        //add to the previous item
                        if (newReturnObj.wordResultArray.length > 0) {
                            newReturnObj.wordResultArray[newReturnObj.wordResultArray.length - 1].nextInsertedWord += node.letter;
                        } else {
                            tmpPreviousWord += node.letter;
                        }
                        needPush = false;

                        wholeWordCount++;
                    }
                    //对于插入的node要记录下来,为后面的标点插入进行参考
                    _.each(punctuationArr, (item, subIndex) => {
                        if (item.index > node.j) {
                            item.index = item.index + 1;
                        }
                    });

                    break;
                // delete operation was done
                case "D":
                    if (!IsNoNeedCompareChar(node.letter)) {
                        //处理识别结果少了儿字的case
                        const prevNode = _.cloneDeep(node);
                        const deleteIndex = prevNode.i;

                        //排斥标点
                        newReturnObj.deletes += 1;
                        wordResultItem.errorType = AzureEnums.WordErrorType.Omission;
                        wordResultItem.word = node.letter;

                        refWordCount++;
                    }
                    break;
                default:
                    break;
            }
            if (needPush) {
                if (tmpPreviousWord.length > 0) {
                    wordResultItem.previousInsertedWord = tmpPreviousWord;
                    tmpPreviousWord = "";
                }
                newReturnObj.wordResultArray.push(wordResultItem);
            }
            newReturnObj.nodeArray.push(node);
        });

        // 2. 比对后，评测文本已经被转成比对结果了，在比对结果里(按照原文位置)加上原文的标点和空格
        _.each(punctuationArr, (item, subIndex) => {
            //修正所有的index
            for (let i = 0; i < newReturnObj.nodeArray.length; i++) {
                let itemd = newReturnObj.nodeArray[i];
                if (i >= item.index) {
                    itemd.i += 1;
                    if (itemd.j) {
                        itemd.j += 1;
                    }
                }
            }
            newReturnObj.nodeArray.splice(item.index, 0, { i: item.index + 1, op: "M", letter: item.letter, from: item.letter, to: item.letter });
        });

        if (parseMarkArr.length > 0 && hasNumberMarkType) {
            const orgNodeArray = _.cloneDeep(newReturnObj.nodeArray);
            newReturnObj.nodeArray = [];
            //3. 处理Mark Text 替换的文字,替换成界面上面显示的文字.重新组装一下
            let currentIndex = 0;
            let insertNodeCount = 0;
            _.each(orgNodeArray, (item, pIndex) => {
                let targetIndex = pIndex;

                if (targetIndex >= currentIndex) {
                    let index = targetIndex - insertNodeCount;
                    if (_.has(markIndexMap, _.toString(index))) {
                        let markItem = markIndexMap[_.toString(index)];

                        //if first item is insert, we just jump this ele?
                        if (item.op === "I") {
                            insertNodeCount += 1;
                            newReturnObj.nodeArray.push(_.cloneDeep(item));
                            targetIndex += 1;
                        }

                        let markParseObj = markItem.markParseObj;
                        if (markParseObj.setting.chnText.length !== markParseObj.text.length) {
                            //替换部分作为一个整体来显示错误情况, 暂定 如果发音的这几个字里,有一个字不是match的情况下,都作为Delete处理
                            let finalFlag = "M";
                            //首先确定flag
                            let allNextNodes = findNextNonInsertNodes(orgNodeArray, targetIndex, markParseObj.setting.chnText);
                            finalFlag = _.every(allNextNodes.nodes, (s) => s.op === "M") ? "M" : "D";
                            //有多余的插入,视为全错
                            if (allNextNodes.insertNodesIndexArr.length > 0) {
                                finalFlag = "D";
                                insertNodeCount += allNextNodes.insertNodesIndexArr.length;
                            }
                            currentIndex = allNextNodes.currentIndex + 1;
                            //只需要按最终结果往里面装node
                            _.each(markParseObj.text, (innerItem, innerIndex) => {
                                //newReturnObj.nodeArray[index + innerIndex] = _.cloneDeep(orgNodeArray[index + innerIndex]);
                                // 先插入已有node. 不够再插入空白
                                if (innerIndex < markParseObj.setting.chnText.length) {
                                    let currentItem = _.cloneDeep(allNextNodes.nodes[innerIndex]);
                                    currentItem.from = innerItem;
                                    currentItem.letter = innerItem;
                                    currentItem.op = finalFlag;
                                    newReturnObj.nodeArray.push(currentItem);
                                } else {
                                    newReturnObj.nodeArray.push({
                                        i: index + innerIndex,
                                        j: index + innerIndex,
                                        op: finalFlag,
                                        letter: innerItem,
                                        from: innerItem,
                                        to: finalFlag === "M" ? innerItem : "",
                                    });
                                    currentIndex += 1;
                                }
                            });
                        } else {
                            let allNextNodes = findNextNonInsertNodes(orgNodeArray, targetIndex, markParseObj.setting.chnText);
                            currentIndex = allNextNodes.currentIndex + 1;
                            let finalFlag = "M";
                            //首先确定flag
                            finalFlag = _.every(allNextNodes.nodes, (s) => s.op === "M") ? "M" : "D";
                            //有多余的插入,视为全错
                            if (allNextNodes.insertNodesIndexArr.length > 0) {
                                finalFlag = "D";
                                insertNodeCount += allNextNodes.insertNodesIndexArr.length;
                            }
                            //个数一样的直接替换,不必考虑flag
                            _.each(markParseObj.text, (innerItem, innerIndex) => {
                                //we need skip the insert char here
                                //newReturnObj.nodeArray[index + innerIndex] = _.cloneDeep(orgNodeArray[index + innerIndex]);
                                let currentItem = _.cloneDeep(allNextNodes.nodes[innerIndex]);
                                currentItem.letter = innerItem;
                                currentItem.from = innerItem;
                                currentItem.op = finalFlag;
                                newReturnObj.nodeArray.push(currentItem);
                            });
                        }
                    } else {
                        if (item.op === "I") {
                            insertNodeCount += 1;
                        }
                        newReturnObj.nodeArray.push(_.cloneDeep(item));
                        currentIndex = pIndex + 1;
                    }
                }
            });
        }
        //how can we say passed. for now we say if you are no word wrong as passed
        newReturnObj.passed = newReturnObj.matches === refWordCount && refWordCount === wholeWordCount;
        newReturnObj.accuracyScore = refWordCount !== 0 ? (newReturnObj.matches / refWordCount) * 100 : 0; //calc match %
        //we need combine the insert part into the previous or backend word to make the Word/Letter Component can show it
        newReturnObj.passedWordCount = newReturnObj.matches;
        newReturnObj.wholeWordCount = wholeWordCount;

        //decode result
        newReturnObj.rawResult = result;
        newReturnObj.referenceText = referenceText;
        let wordResultArray = newReturnObj.wordResultArray;
        for (let i = 0; i < wordResultArray.length; ++i) {
            let item = wordResultArray[i];
            item.word = codec.decode(item.word);
        }
        let nodeArray = newReturnObj.nodeArray;
        for (let i = 0; i < nodeArray.length; ++i) {
            let item = nodeArray[i];
            if (item.letter) {
                item.letter = codec.decode(item.letter);
            }
            if (item.from) {
                item.from = codec.decode(item.from);
            }
            if (item.to) {
                item.to = codec.decode(item.to);
            }
        }

        return {
            shouldResolve: true,
            rejectMessage: "",
            result: newReturnObj,
        };
    } catch (e) {
        return { shouldResolve: false, rejectMessage: t(`${i18nKey}:ServerError`), result: {} };
    }
};

const handleCommonRecognitionResultAutoCheckLanguage = (result, referenceText, referenceSyllableArray, markText) => {
    // 默认按中文处理
    let isEnglish = false;
    if (referenceText) {
        if (!hasChineseChars(referenceText)) {
            isEnglish = true;
        }
    }

    if (!isEnglish) {
        return handleCommonRecognitionResult(result, referenceText, referenceSyllableArray, markText);
    } else {
        return handleCommonRecognitionResultForEnglish(result, referenceText, null, markText);
    }
};

//endregion

export { handleCommonRecognitionResultAutoCheckLanguage };
